import { type ComponentChildren } from 'preact'

interface SecondaryPageProps {
	children: ComponentChildren
}

export default function SecondaryPage({ children }: SecondaryPageProps) {
	return <div className="">{children}</div>
}
